export default __webpack_public_path__ + "img/WF_250MA.fb5cc94eabb96d0403098f4db5e0d317.jpg";